import {
  createDailyStrikeScreenModel,
  type DailyStrikeScreenProps,
} from './DailyStrikeScreenModelScreen';
import { DailyStrikeScreenController } from './DailyStrikeScreenController';
import { DailyStrikeScreenView } from './DailyStrikeScreenView';

export type { DailyStrikeScreenProps } from './DailyStrikeScreenModelScreen';

export function DailyStrikeScreen(props: DailyStrikeScreenProps) {
  const model = createDailyStrikeScreenModel(props);
  const controller = new DailyStrikeScreenController(model);

  return <DailyStrikeScreenView model={model} controller={controller} />;
}
